module.exports = __webpack_public_path__ + "static/img/icon_dxdzz.62944d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_dxdzz.png
// module id = rcsK
// module chunks = 1